<script setup lang="ts">
import { inject, computed } from 'vue';
import { injectionKeys as litiumKeys } from '@motillo/drapejs-litium';
import { configuratorStateKey } from '../ProductConfiguratorKeys';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
const { configuratorState } = inject(configuratorStateKey);
const emit = defineEmits(['edit']);
const toLitiumMediaUrl = inject(litiumKeys.toLitiumMediaUrlKey, () => '');
const { websiteText } = useWebsiteTexts();

const props = defineProps({
  placements: {
    type: Array,
    required: true,
  },
});

const imageSource = computed(() => {
  const id = configuratorState.value.selections.fileUpload.systemId;
  return toLitiumMediaUrl(id, { maxWidth: 124 });
});

function getSelectedPlacementData() {
  return props.placements.find(p => {
    return p.systemId === configuratorState.value.selections.selectedPlacement;
  });
}

const selectedPlacementText = computed(() => {
  const placement = getSelectedPlacementData();
  return `${websiteText('decoration__placement').value}: ${placement.position.name || placement.position.value}`;
});

const selectedTechniqueText = computed(() => {
  const placement = getSelectedPlacementData();
  const technique = placement.techniques
    .find(t => t.systemId === configuratorState.value.selections.selectedTechnique);
  return `${websiteText('decoration__technique').value}: 
    ${technique.name || websiteText(`decoration__technique_${technique.code.toLowerCase()}`).value}`;
});
</script>

<template>
  <div class="decoration-summary">
    <p class="decoration-summary__title">
      {{ websiteText('decoration__added_decoration').value }}
    </p>
    <div class="decoration-summary-container">
      <img
        class="decoration-summary__image"
        :src="imageSource"
        alt="Decoration image"
      >
      <div class="decoration-summary__description">
        <button
          class="secondary-button decoration-summary__edit-button"
          @click="emit('edit', 'pickTechnique')"
        >
          <img src="../../../static/icons/pen_icon.svg" alt="upload-icon" />
          {{ websiteText('global__edit').value }}
        </button>
        <div class="decoration-summary__texts">
          <p class="decoration-summary__placement">
            {{selectedPlacementText}}
          </p>
          <p class="decoration-summary__technique">
            {{selectedTechniqueText}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .decoration-summary {
    margin-bottom: 27px;
  }

  .decoration-summary__title{
    color: var(--color-text-darker);
    font-size: 14px;
    margin: 0 0 15px;
    user-select: none;
  }

  .decoration-summary-container {
    display: flex;
  }

  .decoration-summary__image {
    width: 127px;
    height: 127px;
    margin-right: 15px;
    user-select: none;
  }

  .decoration-summary__description {
    display: grid;
    width: 100%;
  }

  button.decoration-summary__edit-button {
    justify-self: flex-end;
    display: grid;
    grid-auto-flow: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 7.5px 20px;
  }

  .decoration-summary__texts {
    align-self: flex-end;
  }

  .decoration-summary__placement,
  .decoration-summary__technique {
    margin: 0;
    font-size: 12px;
    line-height: 17px;
    color: var(--color-text-darker);
  }
</style>
